import React from "react";

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/919842084477"
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="fixed right-4 bottom-6 bg-[#25D366] text-white p-3 rounded-full shadow-lg"
    >
      💬
    </a>
  );
}
